const API_URL = process.env['NX_API_URL'];
const API_CHECKLIST_URL = process.env['NX_CHECKLIST_BE_URL']

export const apiEndpoints = {
  forgotPassword: `${API_URL}/purchase-manager/forgot-password/sendEmail`,
  setPassword: `${API_URL}/purchase-manager/forgot-password/setNewPassword`,
  emailValidation: `${API_URL}/purchase-manager/email-validation`,
  emailValidationById: `${API_URL}/purchase-manager/email-validation/:id`,
  emailVerifiedByHash: `${API_URL}/purchase-manager/email-validation/emailVerified/:emailHash`,
  socialIdentification: `${API_URL}/purchase-manager/email-validation/socialIdentification`,
  socialLogin: `${API_URL}/purchase-manager/email-validation/socialLogin`,
  googleNonce: `${API_URL}/purchase-manager/email-validation/socialLogin/googleNonce`,
  packageInfo: `${API_URL}/package-manager/package/packageInfo/name/:id`,
  loginUrl: `${API_URL}/package-manager/subscription/getLoginUrl/:id`,
  packageDetail: `${API_URL}/package-manager/package/hash/:hash`,
  setMarketingInfo: `${API_URL}/package-manager/subscription/setMarketingInfo/:id`,
  setWebinarData: `${API_URL}/purchase-manager/webinar/create/:id`,
  getWebinarOptionsByAi: `${API_URL}/package-manager/kllm/getKllmTitleAndDescriptionOptions/:text`,
  buildPlan: `${API_URL}/package-manager/subscription/create/:hash`,
  calculateSummary: `${API_URL}/package-manager/subscription/estimate/:hash`,
  calculateSummaryBySubscriptionId: `${API_URL}/package-manager/subscription/estimateBaseOnSubscriptionId/:subscriptionId`,
  updateBillingAddress: `${API_URL}/purchase-manager/partner/billingAddress`,
  login: `${API_URL}/purchase-manager/partner/login`,
  loginByEmail: `${API_URL}/purchase-manager/email-validation/emailLogin`,
  createAccountUrl: `${API_URL}/purchase-manager/partner/register/:token`,
  subscriptionOverview: `${API_URL}/package-manager/subscription-overview`,
  logout: `${API_URL}/purchase-manager/partner/logout`,
  unsubscribePlan: `${API_URL}/package-manager/subscription/doAction/:id/unsubscribe`,
  updatePlan: `${API_URL}/package-manager/subscription/doAction/:id/upgrade`,
  billingInfo: `${API_URL}/purchase-manager/partner/card`,
  createPaymentIntent: `${API_URL}/purchase-manager/partner/createPaymentIntent/:amount`,
  createCardWithIntent: `${API_URL}/purchase-manager/partner/createCardUsingPaymentIntent`,
  applyCoupon: `${API_URL}/package-manager/subscription/applyCoupon/:planId/:couponId`,
  removeCoupon: `${API_URL}/package-manager/subscription/removeCoupon/:planId/:couponId`,
  couponInfo: `${API_URL}/package-manager/coupon/remoteRefId/:couponId`,
  addPlan: `${API_URL}/purchase-manager/partner/loginWithJwtForm`,
  catalogItems: `${API_URL}/package-manager/admin/catalogItems/list`,
  packageItem: `${API_URL}/package-manager/package/name/:name`,
  packageList: `${API_URL}/package-manager/package`,
  packageItemUpdate: `${API_URL}/package-manager/package/:name`,
  packageItemCreate: `${API_URL}/package-manager/package`,
  planItem: `${API_URL}/package-manager/plan/:name`,
  useCases: `${API_URL}/package-manager/subscription/getUseCases/:id`,
  setUseCases: `${API_URL}/package-manager/subscription/setUseCases/:id`,
  partners: `${API_URL}/purchase-manager/admin/reportItems/list`,
  subscriptions: `${API_URL}/package-manager/admin/partnerSubscription/list`,
  downloadSubscriptionCsv: `${API_URL}/package-manager/admin/partnerSubscription/downloadList/csv`,
  downloadPartnersCsv: `${API_URL}/purchase-manager/admin/reportItems/downloadList/csv`,
  purchaseManagerVersion: `${API_URL}/purchase-manager/system/version`,
  packageManagerVersion: `${API_URL}/package-manager/system/version`,
  chargebeeWebhookVersion: `${API_URL}/chargebee-webhook-listener/system/version`,
  purchaseManagerErrors: `${API_URL}/purchase-manager/admin/error/stats`,
  packageManagerErrors: `${API_URL}/package-manager/admin/error/stats`,
  chargebeeWebhookErrors: `${API_URL}/chargebee-webhook-listener/CHARGEBEE_WEBHOOKS/error/stats`,
  scannerErrors: `${API_URL}/scanner/scanner/error/stats`,
  extendPlanDate: `${API_URL}/package-manager/admin/updateTrialEnd/:subscriptionId`,
  kava: 'https://analytics.kaltura.com/api_v3/index.php',
  raiseAnalyticEvents: `${API_URL}/purchase-manager/partner/raiseAnalyticEvents/:name`,
  checklists: `${API_CHECKLIST_URL}/checklist/findAll`,
  checklistUpdate: `${API_CHECKLIST_URL}/checklist/update/:id`,
  checklistCreate: `${API_CHECKLIST_URL}/checklist/createChecklist`,
  packageByProductFamily: `${API_URL}/package-manager/package/productFamily/:productFamily`,
  loginForUpgrade: `${API_URL}/package-manager/subscription/loginForUpgrade`,
  getUsageSummary: `${API_URL}/package-manager/subscription/getUsageSummary`,
  funnelAnalyticsEvent: `${API_URL}/purchase-manager/analytics/sendFunnelAnalyticsEvent`,
  kavaAnalytics: `${API_URL}/purchase-manager/analytics/sendKavaAnalyticsEvent`,
};
